import { createContext, useContext, ReactNode } from 'react';
import type { ImageTransform } from './imageSizing';

const ImageTransformContext = createContext<ImageTransform | undefined>(undefined);

export function ImageTransformProvider({
  transform,
  children,
}: {
  transform: ImageTransform;
  children: ReactNode;
}) {
  return (
    <ImageTransformContext.Provider value={transform}>{children}</ImageTransformContext.Provider>
  );
}

export function useImageTransform(): ImageTransform | undefined {
  return useContext(ImageTransformContext);
}
